import { Lang } from "@/i18n-config";

export const getPricingDataQueryKeyMap = (lang: Lang) =>
  ({
    pricingTiers: `pricing-tiers-${lang}`,
    pricingQuestions: `pricing-questions-${lang}`,
  } as const);

export const getUserLimitationsQueryKeyMap = () =>
  ({
    userLimitations: "user-limitations",
  } as const);

export const getStockMiningConfigQueryKeyMap = () =>
  ({
    stockMiningConfig: "revenue-breakdown-config",
  } as const);

export const publicDataQueryKeys = [
  ...new Set([
    ...Object.values(getPricingDataQueryKeyMap("en")),
    ...Object.values(getPricingDataQueryKeyMap("zh")),
    ...Object.values(getUserLimitationsQueryKeyMap()),
    ...Object.values(getStockMiningConfigQueryKeyMap()),
  ]),
];

export type PublicDataQueryKey = (typeof publicDataQueryKeys)[number];
